import type { TOC } from '@ember/component/template-only';

import GenieRoutinesDetailComponent from 'webapp/components/genie/routines/detail';
import type { RoutineDetailModel } from 'webapp/routes/routines/detail';

interface Args {
	model: RoutineDetailModel;
}

const RoutinesDetailRouteTemplate: TOC<Args> = <template>
	<GenieRoutinesDetailComponent @routineId={{@model.routineId}} />
</template>;

export default RoutinesDetailRouteTemplate;
